import React, { useMemo, useRef } from 'react';

import { getLanguage, getTimezone } from 'helpers/locale';
import { INVOICING_INTEGRATION_KEY } from 'root/apps/QuoteMachineIntegration/utils/referenceHelpers';

import { CUSTOMER_INVOICES_LIST_ELEMENT } from './config';
import {
  buildCreditAccountRef,
  useCustomerInvoicesListWebComponent,
} from './useCustomerProfileWebComponents';
import { getWebComponentCompatConfig } from './webComponentCompatConfig';

import type {
  CustomerInvoicesListWebComponentConfig,
  CustomerInvoicesListWebComponentHostProps,
} from './types';

export function CustomerInvoicesListWebComponentHost({
  accountID,
  customerId,
  creditAccountId,
}: CustomerInvoicesListWebComponentHostProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  const wcConfig = useMemo(
    (): CustomerInvoicesListWebComponentConfig => ({
      ...getWebComponentCompatConfig(),
      baseUrl: `${window.location.origin}/admin/invoicing`,
      locale: getLanguage(),
      timezone: getTimezone(),
      customHeaders: {},
      integrationKey: INVOICING_INTEGRATION_KEY,
      accountId: accountID,
      customerId,
      creditAccountRef: buildCreditAccountRef(creditAccountId),
      creditAccountId,
    }),
    [accountID, creditAccountId, customerId]
  );

  useCustomerInvoicesListWebComponent(containerRef, wcConfig);

  return (
    <div
      ref={containerRef}
      data-testid="customer-invoices-list-wc-host"
      data-wc-tag={CUSTOMER_INVOICES_LIST_ELEMENT}
    />
  );
}
